import {AfterViewInit, Component, EventEmitter, OnInit, Output} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import * as moment from 'moment';
import { Store } from 'src/app/core/store/store';
import { DatePipe, Location } from '@angular/common';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { PartnerService } from 'src/app/shared/services/partner.service';
declare function closeNavMobile(): any;
@Component({
  selector: 'app-program-element',
  templateUrl: './program-element.component.html',
  styleUrls: ['./program-element.component.css']
})
export class ProgramElementComponent implements OnInit {
  constructor(private partnerService: PartnerService, private store: Store, private route: ActivatedRoute, private router: Router, private location: Location, private datePipe: DatePipe) { }
  page: any;
  totalRating = 4.5;
  starSize = '1.6rem';
  elements: any;
  selectedElement: any;
  groups: any;
  selectedElementDropdown: any;
  learnerDetails: any;
  filteredLearners: any;
  habitDrills: any;
  filteredHabitDrills: any;
  habitDrillResponses: any;
  filteredHabitDrillResponses: any;
  filteredGroups: any;
  selectedValue: any = 'Completion: high to low';
  selectedGroup: any;
  groupMetrics: any;
  habitDrillMap: any;
  habitDrillColumns: any;
  isReadMore = true;
  queryParam: string;
  currentOrganization: string;
  currentActivation: string;
  courseScoreNull: [] = [];
  hideScoreColumn = false;
  readMore = false;
  avgTimeSpent: {
    totalTimeattendedLive: number;
    totalTime: number; count: number } = { totalTime: 0, count: 0, totalTimeattendedLive: 0 };
  learnerMap =  {};
  @Output() hideSidebar = new EventEmitter<boolean>();

  public dropDownData: any = [
    { name: 'Completion: high to low', value: 'COMPLETION_HIGH_TO_LOW' },
    { name: 'Completion: low to high', value: 'COMPLETION_LOW_TO_HIGH' },
    { name: 'Time Spent: high to low', value: 'TIME_SPENT_HIGH_TO_LOW' },
    { name: 'Time Spent: low to high', value: 'TIME_SPENT_LOW_TO_HIGH' },
    { name: 'Score: high to low', value: 'SCORE_HIGH_TO_LOW' },
    { name: 'Score: low to high', value: 'SCORE_LOW_TO_HIGH' },

  ];

  public dropDownDataPrePost: any = [
    { name: 'Completion: high to low', value: 'COMPLETION_HIGH_TO_LOW_PRE' },
    { name: 'Completion: low to high', value: 'COMPLETION_LOW_TO_HIGH_PRE' },
    { name: 'Time Spent: high to low', value: 'TIME_SPENT_HIGH_TO_LOW' },
    { name: 'Time Spent: low to high', value: 'TIME_SPENT_LOW_TO_HIGH' },
    { name: 'Score: high to low', value: 'SCORE_HIGH_TO_LOW' },
    { name: 'Score: low to high', value: 'SCORE_LOW_TO_HIGH' },

  ];

  sortCriteriaMap: any = {
    COMPLETION_HIGH_TO_LOW: (a, b) => (a.progress > b.progress) ? -1 : (a.progress < b.progress) ? 1 : 0,
    COMPLETION_LOW_TO_HIGH: (a, b) => (a.progress > b.progress) ? 1 : (a.progress < b.progress) ? -1 : 0,
    TIME_SPENT_LOW_TO_HIGH: (a, b) => (a.spenttime && !b.spenttime) ? 1 : (!a.spenttime && b.spenttime) ? -1 : 0,
    TIME_SPENT_HIGH_TO_LOW: (a, b) => (a.spenttime && !b.spenttime) ? -1 : (!a.spenttime && b.spenttime) ? 1 : 0,
    SCORE_HIGH_TO_LOW: (a, b) => (a.score > b.score) ? -1 : (a.score < b.score) ? 1 : 0,
    SCORE_LOW_TO_HIGH: (a, b) => (a.score > b.score) ? 1 : (a.score < b.score) ? -1 : 0,
    COMPLETION_HIGH_TO_LOW_PRE: (a, b) => (a.iscompleted && !b.iscompleted) ? -1 : (!a.iscompleted && b.iscompleted) ? 1 : 0,
    COMPLETION_LOW_TO_HIGH_PRE: (a, b) => (a.iscompleted && !b.iscompleted) ? 1 : (!a.iscompleted && b.iscompleted) ? -1 : 0,
    RECORDING_WATCHED_TIME_LOW_TO_HIGH: (a, b) => a?.spenttime  - b?.spenttime,
    RECORDING_WATCHED_TIME_HIGH_TO_LOW: (a, b) => -a?.spenttime + b?.spenttime,
    SESSION_ATTENDANCE_TIME_HIGH_TO_LOW: (a, b) => -a?.attendeLiveDuration + b?.attendeLiveDuration,
    SESSION_ATTENDANCE_TIME_LOW_TO_HIGH: (a, b) => a?.attendeLiveDuration - b?.attendeLiveDuration,
  };
  userTimezone: string;
  protected readonly parseFloat = parseFloat;

  ngOnInit(): void {
    this.store.select<any>('elements').subscribe((elements) => {
      const hMap = {};
      const hUserMap = {};

      /*
      *  For each element, prepare UI friendly data from API
      *
      *
      */
      this.store.select<string>('userTimeZone').pipe(distinctUntilChanged()).subscribe((timezone) => {
        this.userTimezone = timezone;
      });

      this.elements = elements?.elements ? elements.elements.map((e) => {
        if (typeof e?.startDate === 'string' && e?.startDate?.includes(' - Default')){
          const pattern = /( \- Default)/g;
          e.startDate = this.datePipe.transform(e.startDate.replace(pattern, ''), 'd MMM y');
        }
        if ( typeof e?.startDate === 'string' && e?.startDate?.includes('Seq. Unlock') || typeof e?.startDate === 'string' && e?.startDate?.includes('Ask CSM')){
          // const pattern = /( \- Default)/g
          // e.startDate = this.datePipe.transform(e.startDate.replace(pattern,''),'d MMM y');
          return {
            ...e, startDateString: e.startDate ? e?.startDate : '', startDate: e.startDate ? parseInt(e.startDate) : 0,
            past: !this.isInt(e.startDate) || parseInt(e.startDate) < moment().valueOf(),
          };
        }else{
          return {
            ...e, startDateString: e.startDate ? this.datePipe.transform(e?.startDate, 'd MMM y') : '', startDate: e.startDate ? parseInt(e.startDate) : 0,
            past: !this.isInt(e.startDate) || parseInt(e.startDate) < moment().valueOf(),
          };
        }
        // e.startDateInCaseOfLateDate= e?.startDate && e?.startDate?.toLowerCase().includes('default') ? this.datePipe.transform(e?.startDate?.replace(' - Default',''),'d MMM y') : '';

      }) : [];

      if (this.elements.length > 0) {
        this.autoSelectElement();

      } else {
        this.selectedElement = '';
      }

      this.habitDrills = elements?.habitDrills ? elements.habitDrills.map((h) => {
        hMap[h.course_habit_drill_id] = { course: h.course_title, title: h.hd_title };

        return { ...h };
      }) : [];


      this.habitDrillMap = hMap;

       /*
      *  For each habit drill response, aggregate based on user id and course
      *
      *
      */
      this.habitDrillResponses = elements?.habitDrillResponses ? elements.habitDrillResponses.map((h) => {
        if (h.hd_id) {

          if (hMap[h.hd_id]) {

            const hd = hMap[h.hd_id];
            const responseKey = `${h.userid}|${hd.course}`;

            if (hd) {
              const newItem = { [`"${hd.title}" Rating`]: h.hd_rating, [`"${hd.title}" Completed On`]: this.convertUnlockDateTimeString(this.convertMasterClassTime(h.hd_date_submission, this.userTimezone))  };
              hUserMap[responseKey] = hUserMap[responseKey] ? { ...hUserMap[responseKey], ...newItem } : { ...newItem };
            }
          }

        }
        return h;
      }) : [];

      const groupMap = {};

       /*
      *  To populate the learner's table, massage the data to an UI friendly format
      *
      *
      */
      this.learnerDetails = elements?.learnerDetails ? elements.learnerDetails.map((l) => {
        groupMap[l.usergroup] = true;
        return {
          ...l, progress: Math.ceil(l.progress),
          name: l.firstName && l.lastName ? `${l.firstName} ${l.lastName}` : l.firstName ? l.firstName : l.lastName,
          habitDrills: hUserMap[`${l.userid}|${l.item_title}`] || {}
        };

      }

      ) : [];

      this.groups = elements?.groups ? elements.groups.filter((g) => groupMap[g.mc_usergroup]) : [];
      if (this.selectedElement) {
        const load = this.queryParam ? true : false;
        this.onElementChange(this.selectedElement.title, load);
      }
    });

    this.store.select<string>('currentOrganization').pipe(distinctUntilChanged()).subscribe((organization) => {
      this.currentOrganization = organization;
    });

    this.store.select<string>('currentActivationTitle').pipe(distinctUntilChanged()).subscribe((activation) => {
      this.currentActivation = activation;
    });
    this.store.select<any>('learnerDetailMap').subscribe((elements) => {
      // tslint:disable-next-line:forin
      for (const learner in elements){
        this.avgTimeSpent.totalTime += elements[learner][this.selectedElement.title]?.spenttime;
        this.avgTimeSpent.totalTimeattendedLive += elements[learner][this.selectedElement.title]?.attendeLiveDuration ? parseFloat(elements[learner][this.selectedElement.title]?.attendeLiveDuration) : 0;
        this.avgTimeSpent.count++;
      }
      this.learnerMap = elements;
    });
    this.route.params.subscribe(
      (params: Params) => {

        const e = params?.id || '';

        this.queryParam = e;

        if (this.elements && this.elements.length > 0) {
          this.autoSelectElement();
          this.onElementChange(this.selectedElement?.title, true);
        }


      }
    );

  }


  getDropDownOptions = () => {
    return this.selectedElement?.type === 'MASTERCLASS' ? [...this.dropDownData.slice(0, 2), { name: 'Session attendance time: high to low', value: 'SESSION_ATTENDANCE_TIME_HIGH_TO_LOW' }, { name: 'Session attendance time: low to high', value: 'SESSION_ATTENDANCE_TIME_LOW_TO_HIGH' }, { name: 'Recording watched time: high to low', value: 'RECORDING_WATCHED_TIME_HIGH_TO_LOW' }, { name: 'Recording watched time: low to high', value: 'RECORDING_WATCHED_TIME_LOW_TO_HIGH' }] : this.dropDownData;
  }



  getLongDateStringWithoutTime(dateNode) {

    if (dateNode) {
      const date = parseInt(dateNode);
      if (isNaN(date)){
        return dateNode ? dateNode : '-';
      }
      return moment(date).format('DD MMM YYYY');
    }
    else {
      return '-';
    }
  }


  getLongDateStringWithTime(dateNode) {

    if (dateNode) {
      const date = parseInt(dateNode);
      return moment(date).format('DD MMM YYYY hh:mm A');
    }
    else {
      return '-';
    }
  }

  isInt(intNode){
    const i = parseInt(intNode);
    if (isNaN(i)){
       return false;
    }
    return true;
  }



  autoSelectElement = () => {
    const consideredElements = this.filterOnlyCoursesAndMasterClasses(this.elements);
    if (this.queryParam) {
      const filteredElements = consideredElements.filter((c) => c.title === this.queryParam);
      this.selectedElement = filteredElements?.length > 0 ? filteredElements[0] : '';
    }
    if (!this.selectedElement) {
      this.selectedElement = consideredElements?.length > 0 ? consideredElements[0] : '';

    }
  }

  getDateLongFormat = (dateNode) => {

    if (dateNode) {
      const dateN = parseInt(dateNode);
      return moment(dateN).format('DD MMM YYYY');
    }
    return 'NA';
  }

  getHabitDrillDetails = (hdArray) => {
    return hdArray.length === 0 ? 'NA' : hdArray.map((h) => `${h.title}: Completed with rating ${h.rating}`).join('\\n');
  }


  onSortChange(sortCriteria: string, selected: string) {
    this.filteredLearners = this.filteredLearners ? this.filteredLearners.sort(this.sortCriteriaMap[sortCriteria]) : [];
    this.selectedValue = selected;
    if (sortCriteria === 'COMPLETION_HIGH_TO_LOW') {
      this.filteredLearners = this.filteredLearners ? this.filteredLearners.sort((a, b) => (b.progress - a.progress || a.completedon - b.completedon)) : [];
    }
    if (sortCriteria === 'COMPLETION_LOW_TO_HIGH') {
      this.filteredLearners = this.filteredLearners ? this.filteredLearners.sort((a, b) => (a.progress - b.progress || a.completedon - b.completedon)) : [];
    } else if (sortCriteria === 'TIME_SPENT_LOW_TO_HIGH') {
      this.filteredLearners = this.filteredLearners ? this.filteredLearners.sort((a, b) => (a.spenttime - b.spenttime)) : [];
      // console.log(this.filteredLearners[0]);
    } else if (sortCriteria === 'TIME_SPENT_HIGH_TO_LOW') {
      this.filteredLearners = this.filteredLearners ? this.filteredLearners.sort((a, b) => ((b.spenttime + b.attendeLiveDuration) - (a.spenttime + a.attendeLiveDuration))) : [];
    }
  }


  getAvg = (num, denom, precision = 1) => {
    if (!num || !denom || denom === 0) {
      return 0;
    }

    return (num / denom).toFixed(precision);
  }

  getRound = (num) => {
    return Math.round(num);
  }

  getPercent = (num, denom) => {

    if (!num || !denom || denom === 0) {
      return 0;
    }

    return Math.round(num * 100 / denom);
  }

  getCompletedAvg = () => {
    if(this.filteredLearners && this.filteredLearners.length > 0){
      if (this.selectedElement?.type === 'MASTERCLASS') {
        const num = this.groupMetrics?.completed || 0;
        const denom = this.groupMetrics?.total || 0;
  
        return this.getAvg(num * 100, denom, 0);
      }
  
      if (this.selectedElement?.type === 'COURSE') {
        const comp = this.selectedElement?.completed || 0;
        const notStarted = this.selectedElement?.notStarted || 0;
        const inProgress = this.selectedElement?.inProgress || 0;
        let total = 0;
        this.filteredLearners.forEach((f) => {
          total = f.progress ? total + f.progress : total;
        });
  
        return this.getAvg(total, (comp + notStarted + inProgress), 0);
      }
  
      if (this.selectedElement?.type === 'PRE' || this.selectedElement?.type === 'POST') {
        const denom = this.filteredLearners.length || 0;
        let num = 0;
        this.filteredLearners.forEach((f) => {
          num = f.score !== null ? num + 1 : num;
        });
  
        return this.getAvg(num * 100, denom, 0);
      }
      if (this.selectedElement?.type === 'ASSESSMENT') {
        const comp = this.selectedElement?.completed || 0;
        const notStarted = this.selectedElement?.notStarted || 0;
        const inProgress = this.selectedElement?.inProgress || 0;
        let total = 0;
        this.filteredLearners.forEach((f) => {
          total = f.progress ? total + f.progress : total;
        });
        return this.getAvg(total, (comp + notStarted + inProgress), 0);
      }
      return 0;
    }
  

  }


  filterOnlyCoursesAndMasterClasses(es) {
    // return es.filter((e) => e.type === 'COURSE' || e.type === 'MASTERCLASS');
    return es;

  }

  filterOnlySelectedElement(es) {
    // console.log(es[0], 'eseseses');
    // console.log(this.selectedElement, 'this.selectedElementthis.selectedElement')
    const fs = es.filter((e) => e.item_title === this.selectedElement?.title);
    // const fs = es;
    // console.log(fs, 'fs+++++++++++++++++')
    if (this.selectedElement?.type === 'MASTERCLASS' && this.selectedGroup) {
      this.groupMetrics = {};
      const gfs = fs.filter((e) => e.usergroup === this.selectedGroup.mc_usergroup);
      let completed = 0;
      const total = gfs ? gfs.length : 0;
      let totalRatingCount = 0, ratingsHistogram = [0, 0, 0, 0, 0], totalRatings = 0;

      const groupStartDate = this.selectedGroup.mc_date;
      gfs.forEach(element => {

        if (element.progress >= 100) {
          completed = completed + 1;
        }

        if (element.rating) {
          ratingsHistogram[element.rating - 1] = ratingsHistogram[element.rating - 1] + 1;
          totalRatingCount = totalRatingCount + 1;
          totalRatings = totalRatings + element.rating;
        }
      });
      this.groupMetrics = { total, totalRatingCount, totalRatings, ratingsHistogram, completed, startDateString: this.datePipe.transform(groupStartDate, 'd MMM y') };

      return gfs;
    }

    return fs;
  }

  convertMasterClassTime(time, zone){
    const d = new Date(parseInt(time));
    const inititalDate = new Date(d.setUTCMinutes(d.getUTCMinutes() + d.getTimezoneOffset()));
    return new Date(inititalDate.setUTCMinutes(inititalDate.getUTCMinutes() + this.convertMinutes(zone))).getTime().toString();
  }

  convertUnlockDateTimeString(time){
    return new Date(parseInt(time)).toLocaleDateString('en', { year: 'numeric', month: 'short' , day: '2-digit' , hour: '2-digit', minute: '2-digit'});
  }

  convertMinutes(time){
    if (time){
      const timeParts = time.split(':');
      return Number(timeParts[0]) * 60 + Number(timeParts[1]);
    }

  }

  filterHabitDrills(es) {
    const fs = es.filter((e) => e.course_title === this.selectedElement?.title);
    this.filteredHabitDrills = fs;
    this.filterHabitDrillResponses();
  }

  filterHabitDrillResponses() {

    const cols = [];
    if (this.filteredHabitDrills) {
      const filteredHabitDrillResponses = [];
      this.filteredHabitDrills.forEach((e) => {
        cols.push(`"${e.hd_title}" Completed On`);
        cols.push(`"${e.hd_title}" Rating`);
        let bodyText = '';
        bodyText = e.hd_body.replace('<br>', ' ');
        let response = 0;
        if (this.habitDrillResponses) {
          this.habitDrillResponses.forEach((f) => {
            if (f.hd_date_submission && f.hd_id === e.course_habit_drill_id) {
              response = response + 1;
            }
          });
        }

        filteredHabitDrillResponses.push({ response, id: e.course_habit_drill_id, hd_body: bodyText, hd_title: e.hd_title });
      });
      this.filteredHabitDrillResponses = filteredHabitDrillResponses;
    }

    this.habitDrillColumns = cols;
  }


  filterUserGroups(es) {
    return es.filter((e) => e.title === this.selectedElement?.title);
  }

  onElementChange(title: string, updateURL?: boolean) {
    const selectedElements = this.elements.filter((e) => e.title === title);
    this.selectedGroup = null;
    this.groupMetrics = null;
    if (selectedElements?.length > 0) {
      this.selectedElement = selectedElements[0];
      this.filteredHabitDrills = this.filterHabitDrills(this.habitDrills);
      this.filteredGroups = this.filterUserGroups(this.groups);
      if (this.selectedElement.type === 'MASTERCLASS' && this.filteredGroups?.length > 0) {
        const storedGroup = sessionStorage.getItem('currentGroup');
        const storedGroups = storedGroup ? this.filteredGroups.filter((g) => g.mc_usergroup === storedGroup) : [];
        this.selectedGroup = storedGroups?.length > 0 ? storedGroups[0] : this.filteredGroups[0];
        sessionStorage.setItem('currentGroup', this.selectedGroup.mc_usergroup);
      }
      else {
        this.selectedGroup = null;
      }
      // console.log(this.learnerDetails, 'this.learnerDetails++++++++++++++++');
      this.filteredLearners = this.filterOnlySelectedElement(this.learnerDetails);
      console.log(this.filteredLearners, 'this.filteredLearners++++++++++++++++');
      this.courseScoreNull = this.filteredLearners.filter(element => element.score == null); // to check if all learner score null and remove scroe column
      if (this.courseScoreNull.length == this.filteredLearners.length) { this.hideScoreColumn = true; }
      const criteria = this.selectedElement.type === 'PRE' || this.selectedElement.type === 'POST' ? 'COMPLETION_HIGH_TO_LOW_PRE' : 'COMPLETION_HIGH_TO_LOW';
      this.selectedValue = 'Completion: high to low';
      this.filteredLearners = this.filteredLearners.sort(this.sortCriteriaMap[criteria]);
      this.avgTimeSpent.totalTime = 0;
      this.avgTimeSpent.count = 0;
      this.avgTimeSpent.totalTimeattendedLive = 0;
      for (const learner in this.learnerMap){
        this.avgTimeSpent.totalTime += this.learnerMap[learner][this.selectedElement.title]?.spenttime;
        this.avgTimeSpent.totalTimeattendedLive += this.learnerMap[learner][this.selectedElement.title]?.attendeLiveDuration ? parseFloat(this.learnerMap[learner][this.selectedElement.title]?.attendeLiveDuration) : 0;
        this.avgTimeSpent.count++;
      }

    }
    this.page = 1;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    // console.log(this.filteredLearners, 'this.filteredLearners++++++++++++++++');
    
    if (updateURL && document.location?.href && document.location.href.includes('block')) {
      // this.location.go('/learning-insights/block?elementName=' + title)
      this.router.navigate(['/learning-insights/block/' + title]);
    }
  }

  onGroupChange(id: string) {
    const selectedGroup = this.filteredGroups.filter((e) => e.mc_usergroup === id);

    if (selectedGroup && selectedGroup.length > 0) {
      this.selectedGroup = selectedGroup[0];
      sessionStorage.setItem('currentGroup', this.selectedGroup.mc_usergroup);
    }

    this.filteredLearners = this.filterOnlySelectedElement(this.learnerDetails);

    this.selectedValue = '';
    this.filteredLearners = this.filteredLearners.sort(this.sortCriteriaMap.COMPLETION_HIGH_TO_LOW);

    this.page = 1;
  }

  showSubHeaderDDL() {
    $('.ddlOption ul').toggle();
  }

  showText() {
    this.isReadMore = !this.isReadMore;
  }

formatSec(d){
    if (!d || Math.floor(d / 60) == 0){
      return '-';
    }
    const minString = Math.floor(d / 60) % 60 > 9 ? `${Math.floor(d / 60) % 60} mins` : `${Math.floor(d / 60) % 60} min`;
    return Math.floor(d / 3600) > 0 ? `${Math.floor(d / 3600)} h ` + minString : minString;
}
  downloadReport = () => {

    let headers = ['Learner\'s Name', 'Email', 'Completion', 'Review', 'Rating', 'TimeSpent'];


    const newHabitDrillHeaders = [];

    if (this.habitDrillColumns && this.habitDrillColumns.length > 0) {
      const moreThanTwoHabitDrills = this.habitDrillColumns.length > 2;
      this.habitDrillColumns.forEach((hdCol, i) => {
        const colNamePrefix = moreThanTwoHabitDrills ? `Habitdrill ${Math.floor(i / 2) + 1}` : 'Habitdrill';
        const colNameSuffix = i % 2 === 0 ? 'Completion' : 'Rating';
        newHabitDrillHeaders.push(`${colNamePrefix} ${colNameSuffix}`);
      });
    }

    const data = this.filteredLearners.map((l) => {
      let addlData = {};

      if (this.selectedElement?.type === 'COURSE') {
        addlData = { ...addlData, 'Course Score': l.score !== null ? this.getRound(l.score) : 'NA', 'Course Rating/5' :  l.rating ? l.rating : 'NA', TimeSpent: this.formatSec(l.spenttime) };


        if (this.habitDrillColumns && this.habitDrillColumns.length > 0) {
          const moreThanTwoHabitDrills = this.habitDrillColumns.length > 2;
          this.habitDrillColumns.forEach((hdCol, i) => {
            const colNamePrefix = moreThanTwoHabitDrills ? `Habitdrill ${Math.floor(i / 2) + 1}` : 'Habitdrill';
            const colNameSuffix = i % 2 === 0 ? 'Completion' : 'Rating';
            addlData = { ...addlData, [`${colNamePrefix} ${colNameSuffix}`]: l.habitDrills[hdCol] || 'NA' };
          });
        }
      }

      if (this.selectedElement?.type === 'MASTERCLASS') {
       addlData = { ...addlData, 'Masterclass Attendance': l.progress > 0 ? 'Attended' : 'NA', 'Masterclass Rating/5' :  l.rating ? l.rating : 'NA', TimeSpent: this.formatSec(parseFloat(l.attendeLiveDuration? l.attendeLiveDuration: 0) + parseFloat(l.spenttime?  l.spenttime : 0)) };
      }

      if (this.selectedElement?.type === 'PRE' || this.selectedElement?.type === 'POST') {
        return {
          'Learner\'s Name': l.name,
          Email: l.email,
          Completion: l.score !== null ? 100 : 0,
          'Self-Assessment Score': l.score !== null ? this.getRound(l.score) : 'NA'
        };
      }

      if (this.selectedElement?.type === 'ASSESSMENT') {
        return {
          'Learner\'s Name': l.name,
          Email: l.email,
          Completion: l?.progress,
          Score: this.getRound(l?.score)
        };
      }


      return {
        'Learner\'s Name': l.name,
        Email: l.email,
        Completion: l.progress,
        Review: l.item_review ? l.item_review : '',
        ...addlData
      };
    }
    );

    if (this.habitDrillColumns && this.habitDrillColumns.length > 0) {
      headers = [...headers, ...newHabitDrillHeaders];

    }

    const filename = `Harappa | ${this.currentOrganization} | ${this.currentActivation} | ${this.selectedElement?.title} | Leaderboard`;
    // this.partnerService.downloadFile(data, headers, filename);
    this.partnerService.downloadXlsx(data, filename);
  }
}
